import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { failStatus, successStatus } from '@core/models/request-status.model';
import { Customer } from '@core/user/utilities/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserConnector {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
  ) {}

  get(customerId: string): Observable<Customer> {
    const url = `${environment.apiService}/customer/me?customerId=${customerId}`;
    return this.http.get(url).pipe(
      map(response => ({
        ...successStatus,
        ...this.normalize(response),
      })),
      catchError(() => {
        return this.translateService.get('generic.requestError').pipe(
          map(message => ({
            ...failStatus,
            message,
          })),
        );
      }),
    );
  }

  normalize(data: any): Customer {
    return data;
  }
}
